import { z } from 'zod';
import { SystemLogoDataSchema } from '../../shared/logo.schema';
import { PopulatedUserSchema } from '../user/user.schema';
/**
 * System Schema
 * Represents a software system used in the organization
 * Note: systemOwner can be either a string (ID) or populated user object from API
 */ export const SystemSchema = z.object({
    _id: z.string(),
    name: z.string(),
    description: z.string().optional(),
    logo: SystemLogoDataSchema.optional(),
    systemOwner: z.union([
        z.string(),
        PopulatedUserSchema
    ]),
    category: z.string().optional(),
    url: z.string().optional(),
    licenceSeats: z.number().int().min(0).optional(),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
    deletedAt: z.number().optional()
});
/**
 * System Display Schema
 * Used for show-system endpoint with fully populated references
 * Unlike SystemSchema, this requires systemOwner to be populated
 */ export const SystemDisplaySchema = z.object({
    _id: z.string(),
    name: z.string(),
    description: z.string().optional(),
    logo: SystemLogoDataSchema.optional(),
    systemOwner: PopulatedUserSchema,
    category: z.string().optional(),
    url: z.string().optional(),
    licenceSeats: z.number().int().min(0).optional(),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
    deletedAt: z.number().optional()
});
/**
 * Populated System Schema
 * Used when system references are populated with simplified system data
 * Simplified version for populated references in API responses
 */ export const PopulatedSystemSchema = z.object({
    _id: z.string(),
    name: z.string(),
    description: z.string().optional(),
    logo: SystemLogoDataSchema.optional(),
    systemOwner: z.union([
        z.string(),
        PopulatedUserSchema
    ]),
    category: z.string().optional(),
    url: z.string().optional(),
    licenceSeats: z.number().int().min(0).optional(),
    deletedAt: z.number().optional()
});

//# sourceMappingURL=system.schema.js.map